import { OrderByValue } from 'types';
import { OrderDirections } from 'types/enums';

// The sorting method used by backend if none is specified in request
export const defaultSortingMethod = OrderByValue.Trending;

export const samplesSortingMethods: OrderByValue[] = [
    OrderByValue.Trending,
    OrderByValue.Popularity,
    OrderByValue.Recent,
    OrderByValue.Name,
    OrderByValue.Key,
    OrderByValue.Bpm,
];

export const packsSortingMethods: OrderByValue[] = [
    OrderByValue.Trending,
    OrderByValue.Popularity,
    OrderByValue.Recent,
    OrderByValue.Name,
];

export const defaultSortingMethodDirection: {
    [key in keyof typeof OrderByValue]: OrderDirections;
} = {
    [OrderByValue.Default]: OrderDirections.descending, // Trending
    [OrderByValue.Bpm]: OrderDirections.descending,
    [OrderByValue.Instrument]: OrderDirections.ascending,
    [OrderByValue.Key]: OrderDirections.ascending,
    [OrderByValue.Name]: OrderDirections.ascending,
    [OrderByValue.Pack]: OrderDirections.ascending,
    [OrderByValue.TextSearch]: OrderDirections.ascending,
    [OrderByValue.Recommandation]: OrderDirections.descending,
    [OrderByValue.Popularity]: OrderDirections.descending,
    [OrderByValue.Recent]: OrderDirections.descending,
    [OrderByValue.Trending]: OrderDirections.descending,
};
